import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/previous.svg'
import _imports_1 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-ca6a5752"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "content-item-info p-grid p-flex-wrap"
}
const _hoisted_3 = { class: "left p-col-8 p-grid p-d-flex p-flex-column p-flex-wrap" }
const _hoisted_4 = { class: "video" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "play-img" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-d-flex p-justify-between p-mt-4" }
const _hoisted_9 = { class: "actions p-pl-4 p-d-flex p-flex-wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start" }, null, -1))
const _hoisted_11 = { class: "dates" }
const _hoisted_12 = { class: "stats p-d-flex p-flex-wrap" }
const _hoisted_13 = { class: "stats-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "views", -1))
const _hoisted_15 = { class: "stats-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "likes", -1))
const _hoisted_17 = { class: "stats-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "comments", -1))
const _hoisted_19 = { class: "stats-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "COntent URL", -1))
const _hoisted_21 = { class: "p-mr-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_23 = { class: "right p-col-12 p-lg-3 p-grid" }
const _hoisted_24 = { class: "creator" }
const _hoisted_25 = { class: "tabview-block" }
const _hoisted_26 = {
  key: 0,
  class: "inf-info-block"
}
const _hoisted_27 = {
  key: 1,
  class: "description-block p-col-10"
}
const _hoisted_28 = { class: "p-col-12 p-grid p-d-flex p-flex-wrap p-flex-column" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-d-flex p-justify-between p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-6" }, "More Content from this Author"),
  /*#__PURE__*/_createElementVNode("span", { class: "p-mr-6 cursor" }, "See all >")
], -1))
const _hoisted_30 = { class: "p-d-flex p-flex-wrap p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InfluencerInformation = _resolveComponent("InfluencerInformation")!
  const _component_LatestContentItem = _resolveComponent("LatestContentItem")!
  const _component_app_list_page = _resolveComponent("app-list-page")!

  return (_openBlock(), _createBlock(_component_app_list_page, {
    class: "content-item",
    style: {"padding-left":"22px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", {
        class: "p-ml-3 pointer p-mt-6 p-mb-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_1,
        _createTextVNode(" Content")
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.previewPhoto)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle({ 'background-image': `url(${_ctx.item?.previewPhoto})` }),
                          class: "preview-photo",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewPhoto = false))
                        }, _hoisted_6, 4))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("iframe", {
                      "min-width": "300px",
                      "max-width": "1050px",
                      height: "515px",
                      class: "video-player",
                      src: `https://www.youtube.com/embed/${_ctx.item?.vid}`,
                      title: "YouTube video player",
                      frameborder: "0",
                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_7), [
                      [_vShow, !_ctx.previewPhoto]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.item.title), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Button, { class: "star-btn" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.item.publishedAt), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", null, _toDisplayString(_ctx.compactNumber(_ctx.item?.statistics?.viewCount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", null, _toDisplayString(_ctx.compactNumber(_ctx.item?.statistics?.likeCount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", null, _toDisplayString(_ctx.compactNumber(_ctx.item?.statistics?.commentCount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("span", {
                        class: "copy-url",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyLink(_ctx.item.url)))
                      }, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.item.url), 1),
                        _hoisted_22
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["tab-item", [_ctx.activeTab === 0 ? 'active-tab' : '']]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 0))
                      }, "Author", 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["tab-item", [_ctx.activeTab === 1 ? 'active-tab' : '']]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 1))
                      }, "Description", 2)
                    ]),
                    (_ctx.activeTab === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createVNode(_component_InfluencerInformation, {
                            creator: _ctx.item?.owner,
                            style: {"width":"100%"}
                          }, null, 8, ["creator"]),
                          _createElementVNode("h5", {
                            class: "goTO",
                            style: {"margin-left":"78%"},
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'creator', params: { creatorID: _ctx.item?.owner?.id }})))
                          }, "Go to profile >")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeTab === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.item?.description), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicContentCreator?.contentItems, (content, index) => {
                      return (_openBlock(), _createBlock(_component_LatestContentItem, {
                        onClick: ($event: any) => (_ctx.$router.push({ name: 'content-item', params: { itemID: content?.id }})),
                        favorites: false,
                        item: content,
                        key: `${index}_creator_content`
                      }, null, 8, ["onClick", "item"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}